const shared = {
  caliberTitle: '測定基準バージョンとデータ期限',
  caliber: '基準',
  through: 'データ期限',
  batch: 'バッチ',
  denominator: '分母',
  loading: '測定データを読み込んでいます…',
  readFailure: 'データを読み込めませんでした',
  readFailureClarification: 'AI 結果に企業が存在しないという意味ではありません。読み込みの失敗とは別の事実です。',
  permissionTitle: 'このプロジェクトへのアクセス権がありません',
  permissionBody: '権限のあるプロジェクトに切り替えるか、プロジェクト管理者にアクセス許可を依頼してください。',
  retry: '再読み込み',
  closeEvidence: '証拠を閉じる',
  provenance: {
    real: '実データ',
    construct: '構成データ',
    placeholder: '仮置き',
  },
  session: {
    secureSession: 'セキュアセッション',
    contextTitle: 'Navigator に入る。',
    contextBody: '企業スペースへ安全に進みます。',
    pathLabel: 'アカウント設定の進捗',
    pathOneTitle: 'メールを確認',
    pathOneBody: 'ワンタイムログインリンクは、有効なワークスペースメンバーにのみ送信されます。',
    pathTwoTitle: '企業を選択または作成',
    pathTwoBody: 'このセッションでは、その企業から割り当てられたプロジェクトだけを読み込めます。',
    pathThreeTitle: '作業を開始',
    pathThreeBody: '内部認証情報を公開せず、診断・アクション・成果を再開します。',
    memberEntry: '企業メンバーログイン',
    requestTitle: 'メールで続行。',
    requestLead: '既存メンバーはログインし、新規ユーザーは確認後に企業スペースを作成します。',
    afterLogin: 'ログイン後',
    destination: {
      diagnosis: '診断に戻る',
      results: '成果に戻る',
      action: 'アクションに戻る',
      research: '企業研究に戻る',
    },
    emailLabel: '業務用メール',
    invalidEmail: '有効な業務用メールを入力してください。',
    sendLink: '続行',
    sending: '送信中…',
    privacyTitle: '企業メンバー限定。',
    privacyBody: 'メールはログインと必要なアカウント通知にのみ使用します。',
    checkEyebrow: 'リクエストを受け付けました',
    checkTitle: '受信トレイを確認してください',
    checkLead: '安全なリンクを送信しました。この端末でメールを開いて続行してください。',
    linkLifetime: 'リンクは 15 分間有効',
    resendShort: '再送信',
    changeEmail: '別のメールを使う',
    verifyingEyebrow: 'メンバー資格を確認中',
    verifyingTitle: '企業スペースを開いています',
    verifyingLead: 'ワンタイムリンクを保護されたブラウザセッションに交換しています。',
    expiredEyebrow: 'リンクを利用できません',
    expiredTitle: 'このログインリンクは期限切れか、すでに使用されています',
    expiredLead: '同じ許可済み業務用メールで新しいリンクをリクエストしてください。プロジェクトデータは変更されていません。',
    requestNewLink: '新しいリンクをリクエスト',
    problemEyebrow: '接続が中断されました',
    problemTitle: 'ログインリンクをリクエストできませんでした',
    problemLead: '接続を確認して再試行してください。企業スペースのデータは変更されていません。',
    chooseSpaceEyebrow: '企業スペース',
    chooseSpaceTitle: '今回使用する企業スペースを選択',
    chooseSpaceLead: '{email} は複数の企業スペースにアクセスできます。選択したスペースのデータだけを読み込み、後から切り替えられます。',
    openingSpace: '開いています…',
    chooseSpaceFailed: 'この企業スペースを開けませんでした。もう一度お試しください。',
    createEyebrow: 'メール確認済み',
    createContextTitle: '一つのIDで、所属するすべての企業へ。',
    createContextBody: '企業スペースにはプロジェクト、メンバー、記憶、権限が保存されます。',
    createTitle: '企業スペースを作成。',
    createLead: '基本情報を入力します。個人事業者はブランド名でも作成できます。',
    verifiedIdentity: '確認済み',
    orgName: '企業 / ブランド / チーム名',
    region: '主な事業地域',
    website: 'Webサイト',
    optional: '任意',
    terms: 'この企業を代表する権限があり、規約とプライバシーポリシーに同意します。',
    createButton: '企業スペースを作成',
    creatingWorkspace: '作成中…',
    regionCN: '中国本土',
    regionGlobal: 'その他の国・地域',
    regionHK: '中国香港',
    regionTW: '中国台湾',
    regionJP: '日本',
    regionKR: '韓国',
    createBoundary: '登録だけで有料プランは開始されません。',
    companyNameInvalid: '企業、ブランド、またはチーム名を入力してください。',
    termsRequired: '続行する前に規約に同意してください。',
    registrationFailed: '企業スペースを作成できませんでした。もう一度お試しください。',
    footerSecurity: 'ワンタイムリンク · 保護 Cookie · テナント分離',
    footerHelp: 'サポート · hello@monolithos.ai',
  },
} as const

export default shared
